/**
 * Derives which Home doc-list column is pinned to the left edge, from visible
 * column order and nothing else: the leftmost column that is not the actions
 * column maps to offset 0, and every other id is absent from the map.
 *
 * Called by `HomeFormVersionsTable`, which hands the map to `DocListTable`; the
 * header, body and footer renderers each decide "is this column frozen" by
 * asking this map alone, so membership is the single source of that truth.
 * At most one entry: a second pinned column would need the summed widths of the
 * columns to its left, which no caller measures.
 */

import { ACTIONS_COLUMN_ID } from './DocListTable/constants';

export function getFrozenLeftOffsets(visibleColumnIds: readonly string[]): Map<string, number> {
    const pinnedId = visibleColumnIds.find((id) => id !== ACTIONS_COLUMN_ID);
    return pinnedId === undefined ? new Map() : new Map([[pinnedId, 0]]);
}
